// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as Card from "../../resources/layout-and-structure/Card.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as React from "react";
import * as Banner from "../../resources/feedback-indicators/Banner.res.js";
import * as TextLink from "../../resources/navigation/TextLink.res.js";
import * as InfoBlock from "../../resources/layout-and-structure/InfoBlock.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as Placeholder from "../../resources/layout-and-structure/Placeholder.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as ApolloHelpers from "../../helpers/ApolloHelpers.res.js";
import * as OrderEditForm from "./OrderEditForm.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as SupplierRoutes from "../../app/Supplier/SupplierRoutes.res.js";
import * as SupplierSelect from "../Supplier/SupplierSelect.res.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Primitive_exceptions from "@rescript/runtime/lib/es6/Primitive_exceptions.js";
import * as OrderSupplierInformationCard__Config from "./OrderSupplierInformationCard__Config.res.js";
import * as OrderSupplierInformationCard__Queries from "./OrderSupplierInformationCard__Queries.res.js";

let SupplierNotFound = /* @__PURE__ */Primitive_exceptions.create("OrderSupplierInformationCard.SupplierNotFound");

let make = React.memo(props => {
  let dispatch = OrderEditForm.useFormDispatch();
  let match = OrderEditForm.useFormState();
  let values = match.values;
  let supplierName = values.supplierName;
  let supplierId = values.supplierId;
  let validation = match.validation;
  let archivedSupplierNotification = supplierId === "" && supplierName !== "";
  let errorMessage;
  if (validation.TAG === "Ok") {
    errorMessage = undefined;
  } else {
    let tmp = match.submission;
    errorMessage = typeof tmp !== "object" || tmp.TAG !== "Failed" ? undefined : Stdlib_Array.filterMap(validation._0, param => {
          if (param[0]._0 === "SupplierId") {
            return param[1];
          }
        })[0];
  }
  let value = supplierId !== "" ? ({
      id: supplierId,
      name: supplierName
    }) : undefined;
  let onChange = React.useCallback(value => {
    if (value === undefined) {
      return dispatch({
        TAG: "FieldValueChanged",
        _0: "SupplierId",
        _1: param => ""
      });
    }
    let supplierId = Stdlib_Option.getOr(Primitive_option.fromNullable(value.id), "");
    dispatch({
      TAG: "FieldValueChanged",
      _0: "SupplierId",
      _1: param => supplierId
    });
    dispatch({
      TAG: "FieldValueChanged",
      _0: "SupplierName",
      _1: param => value.name
    });
  }, []);
  return JsxRuntime.jsxs(Stack.make, {
    children: [
      JsxRuntime.jsx(SupplierSelect.make, {
        label: I18n.t("Supplier"),
        preset: {
          NAME: "inputField",
          VAL: {
            required: true,
            errorMessage: errorMessage
          }
        },
        shopId: values.shopId,
        value: value,
        onChange: onChange
      }),
      archivedSupplierNotification ? JsxRuntime.jsx(Banner.make, {
          textStatus: {
            TAG: "Warning",
            _0: I18n.t("The previously selected supplier cannot be found (archived).")
          }
        }) : null
    ],
    space: "normal"
  });
});

let OrderSupplierFormInputSearch = {
  make: make
};

function OrderSupplierInformationCard(props) {
  let editable = props.editable;
  let match = OrderEditForm.useFormState().values;
  let supplierId = match.supplierId;
  let asyncQueryResult = ApolloHelpers.queryResultToAsyncResult(OrderSupplierInformationCard__Queries.SupplierQuery.use(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, supplierId === "", undefined, {
    id: supplierId
  }));
  let selectedSupplierId;
  if (typeof asyncQueryResult !== "object" || asyncQueryResult.TAG !== "Done") {
    selectedSupplierId = supplierId;
  } else {
    let match$1 = asyncQueryResult._0;
    if (match$1.TAG === "Ok") {
      let match$2 = match$1._0.supplier;
      if (match$2 !== undefined) {
        let id = match$2.id;
        selectedSupplierId = id !== "" ? id : supplierId;
      } else {
        selectedSupplierId = supplierId;
      }
    } else {
      selectedSupplierId = supplierId;
    }
  }
  let tmp;
  let exit = 0;
  let data;
  if (match.shopId === "") {
    tmp = JsxRuntime.jsx(Banner.make, {
      textStatus: {
        TAG: "Info",
        _0: I18n.t("Please first select the shop below in order to pick a supplier.")
      }
    });
  } else if (typeof asyncQueryResult !== "object") {
    if (asyncQueryResult === "NotAsked") {
      if (editable) {
        tmp = JsxRuntime.jsx(make, {});
      } else {
        exit = 1;
      }
    } else {
      tmp = JsxRuntime.jsx(Placeholder.make, {
        status: "Loading"
      });
    }
  } else if (asyncQueryResult.TAG === "Reloading") {
    let data$1 = asyncQueryResult._0;
    if (data$1.TAG === "Ok") {
      data = data$1._0;
      exit = 2;
    } else {
      exit = 1;
    }
  } else {
    let data$2 = asyncQueryResult._0;
    if (data$2.TAG === "Ok") {
      data = data$2._0;
      exit = 2;
    } else {
      exit = 1;
    }
  }
  switch (exit) {
    case 1 :
      tmp = JsxRuntime.jsx(Placeholder.make, {
        status: "Error"
      });
      break;
    case 2 :
      let supplier = data.supplier;
      if (supplier !== undefined) {
        let match$3 = supplier.email;
        let match$4 = supplier.phoneNumber;
        let match$5 = supplier.mobileNumber;
        let tmp$1;
        let exit$1 = 0;
        if (match$3 !== undefined || match$4 !== undefined || match$5 !== undefined || !editable) {
          exit$1 = 3;
        } else {
          tmp$1 = null;
        }
        if (exit$1 === 3) {
          let email = supplier.email;
          let phoneNumber = supplier.phoneNumber;
          let mobileNumber = supplier.mobileNumber;
          tmp$1 = JsxRuntime.jsx(Box.make, {
            children: JsxRuntime.jsxs(Stack.make, {
              children: [
                editable ? null : JsxRuntime.jsx(TextLink.make, {
                    text: supplier.companyName,
                    to: {
                      TAG: "Route",
                      _0: SupplierRoutes.showRoute(supplier.id)
                    },
                    openNewTab: true
                  }),
                email !== undefined ? JsxRuntime.jsx(TextStyle.make, {
                    children: email
                  }) : null,
                phoneNumber !== undefined ? JsxRuntime.jsx(TextStyle.make, {
                    children: I18n.phoneNumberFormat(phoneNumber)
                  }) : null,
                mobileNumber !== undefined ? JsxRuntime.jsx(TextStyle.make, {
                    children: I18n.phoneNumberFormat(mobileNumber)
                  }) : null
              ],
              space: "xsmall"
            }),
            spaceTop: editable ? "medium" : undefined
          });
        }
        tmp = JsxRuntime.jsxs(Stack.make, {
          children: [
            editable ? JsxRuntime.jsx(make, {}) : null,
            tmp$1
          ],
          space: editable ? "xxsmall" : undefined
        });
      } else {
        throw {
          RE_EXN_ID: SupplierNotFound,
          Error: new Error()
        };
      }
      break;
  }
  let tmp$2;
  if (typeof asyncQueryResult !== "object" || asyncQueryResult.TAG !== "Done") {
    tmp$2 = null;
  } else {
    let match$6 = asyncQueryResult._0;
    if (match$6.TAG === "Ok") {
      let supplier$1 = match$6._0.supplier;
      if (supplier$1 !== undefined) {
        let contact = OrderSupplierInformationCard__Config.supplierContactFromData(supplier$1);
        let tmp$3;
        if (contact !== undefined) {
          let email$1 = contact.email;
          let phoneNumber$1 = contact.phoneNumber;
          let mobileNumber$1 = contact.mobileNumber;
          tmp$3 = JsxRuntime.jsxs(Stack.make, {
            children: [
              JsxRuntime.jsx(TextStyle.make, {
                children: contact.formattedName
              }),
              email$1 !== undefined ? JsxRuntime.jsx(TextStyle.make, {
                  children: email$1
                }) : null,
              phoneNumber$1 !== undefined ? JsxRuntime.jsx(TextStyle.make, {
                  children: I18n.phoneNumberFormat(phoneNumber$1)
                }) : null,
              mobileNumber$1 !== undefined ? JsxRuntime.jsx(TextStyle.make, {
                  children: I18n.phoneNumberFormat(mobileNumber$1)
                }) : null
            ]
          });
        } else {
          tmp$3 = JsxRuntime.jsx(TextStyle.make, {
            children: I18n.t("Contact information not specified"),
            variation: "subdued"
          });
        }
        let location = OrderSupplierInformationCard__Config.supplierLocationFromData(supplier$1);
        let tmp$4;
        if (location !== undefined) {
          let recipient = location.recipient;
          let address = location.address;
          let formattedCity = location.formattedCity;
          tmp$4 = JsxRuntime.jsxs(Stack.make, {
            children: [
              recipient !== undefined ? JsxRuntime.jsx(TextStyle.make, {
                  children: recipient
                }) : null,
              address !== undefined ? JsxRuntime.jsx(TextStyle.make, {
                  children: address
                }) : null,
              formattedCity !== undefined ? JsxRuntime.jsx(TextStyle.make, {
                  children: formattedCity
                }) : null,
              JsxRuntime.jsx(TextStyle.make, {
                children: location.country
              })
            ]
          });
        } else {
          tmp$4 = JsxRuntime.jsx(TextStyle.make, {
            children: I18n.t("Address not specified"),
            variation: "subdued"
          });
        }
        tmp$2 = JsxRuntime.jsxs(Stack.make, {
          children: [
            JsxRuntime.jsx(InfoBlock.make, {
              children: tmp$3,
              title: I18n.t("CONTACT")
            }),
            JsxRuntime.jsx(InfoBlock.make, {
              children: tmp$4,
              title: I18n.t("ADDRESS")
            })
          ],
          space: "xlarge"
        });
      } else {
        tmp$2 = null;
      }
    } else {
      tmp$2 = null;
    }
  }
  let tmp$5 = selectedSupplierId === "" ? undefined : ({
      icon: "legacy_queue_arrow_right",
      title: I18n.t("See supplier"),
      href: SupplierRoutes.showRoute(selectedSupplierId),
      target: "_blank"
    });
  return JsxRuntime.jsxs(Card.make, {
    children: [
      tmp,
      tmp$2
    ],
    title: I18n.t("Supplier information"),
    action: tmp$5
  });
}

let make$1 = React.memo(OrderSupplierInformationCard);

let Config;

let SupplierQuery;

export {
  Config,
  SupplierQuery,
  SupplierNotFound,
  OrderSupplierFormInputSearch,
  make$1 as make,
}
/* make Not a pure module */
